import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpEventType } from '@angular/common/http';
import { DataService } from '../../../services/data.service';
import { DataSourceGet } from '../../../models/datasource';

@Component({
  selector: 'app-edit-file-upload-datasource',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSnackBarModule
  ],
  templateUrl: './edit-file-upload-datasource.component.html',
  styleUrls: ['./edit-file-upload-datasource.component.scss']
})
export class EditFileUploadDatasourceComponent {
  @Input() dataSource!: DataSourceGet;

  selectedFile: File | null = null;
  uploading = false;
  uploadProgress = 0;
  uploadedBytes = 0;
  totalBytes = 0;
  uploadStatusText = 'Processing...';
  uploadError: string | null = null;

  constructor(
    private dataService: DataService,
    private snackBar: MatSnackBar
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadError = null;
    }
  }

  performReplace(): Observable<boolean> {
    this.uploading = true;
    this.uploadError = null;
    this.uploadProgress = 0;
    this.uploadedBytes = 0;
    this.totalBytes = this.selectedFile?.size || 0;
    this.uploadStatusText = 'Uploading file...';

    return new Observable<boolean>(observer => {
      // No FileReader needed — send file directly as multipart/form-data
      this.dataService.replaceFileDataSourceWithProgress(this.dataSource.dataSourceId!, this.selectedFile!).subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              // Track upload progress
              if (event.total) {
                this.totalBytes = event.total;
                this.uploadedBytes = event.loaded;
                this.uploadProgress = Math.round((100 * event.loaded) / event.total);
              }
            } else if (event.type === HttpEventType.Response) {
              // Upload complete, switch to indeterminate while processing
              this.uploadProgress = 100;
              this.uploadStatusText = 'Processing...';
              
              this.uploading = false;
              observer.next(true);
              observer.complete();
            }
          },
          error: (error: any) => {
            this.uploading = false;
            // Don't display error message for 402 Payment Required - already handled by interceptor
            if (error.status !== 402) {
              this.uploadError = error.message || 'Failed to replace file';
            }
            observer.error(error);
          }
        });
    });
  }

  clearSelection(): void {
    this.selectedFile = null;
    this.uploadError = null;
  }

  getFileSizeString(bytes: number): string {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  }
}
